exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".progress-bar{background:var(--light-gray);position:relative}.progress-bar__loader{height:16px;width:0;transition:.5s;background:var(--green)}.progress-bar__current{left:-5px;white-space:nowrap}.progress-bar__current,.progress-bar__max{position:absolute;top:50%;transform:translateY(-50%);font-size:var(--font-smallest)}.progress-bar__max{right:5px}", ""]);

// exports
